import { nextstepsConstants } from '../constants/actionTypes'
import { fetchnNextSteps } from '../services/nextStepService'
import { NextStepValue } from 'utils/type'

const nextStepsRequest = () => ({
  type: nextstepsConstants.FETCH_NEXTSTEPS_REQUEST,
})

const nextStepsSuccess = (nextSteps) => ({
  type: nextstepsConstants.FETCH_NEXTSTEPS_SUCCESS,
  payload: nextSteps,
})

export const fetchNextsteps = (opportunityId) => {
  return (dispatch) => {
    let nextSteps = {
      step: NextStepValue.NONE,
      link: '',
      isFetching: false,
    }
    dispatch(nextStepsRequest())
    return fetchnNextSteps(opportunityId).then(
      (data) => {
        if (data.atoStatus) {
          data.atoUrl
            ? (nextSteps = {
                step: NextStepValue.ATO,
                link: data.atoUrl,
                isFetching: false,
              })
            : console.error('Error: atoUrl is not provided')
        } else if (data.optOutInsurance) {
          // This is a default action which determines no more user action is needed in the website
          // If this step is true, there is no need to check for either deferred sales / insurance consent
          nextSteps = {
            step: NextStepValue.NONE,
            link: '',
            isFetching: false,
          }
        } else if (
          !data.deferredSalesPeriodClear &&
          data.insuranceConsentStatus
        ) {
          nextSteps = {
            step: NextStepValue.DEFERRED,
            link: '',
            isFetching: false,
          }
        } else if (data.insuranceConsentStatus) {
          data.insuranceConsentUrl
            ? (nextSteps = {
                step: NextStepValue.INSURANCE,
                link: data.insuranceConsentUrl,
                isFetching: false,
              })
            : console.error('Error: insuranceConsentUrl is not provided')
        }

        dispatch(nextStepsSuccess(nextSteps))
      },
      (error) => {
        console.error(`Error: ${error}`)
        dispatch(nextStepsSuccess(nextSteps))
      }
    )
  }
}
